/** Register a market+category pricing rule as a new DRAFT version (the server assigns the next `pricingVersion`). */
export function createPricingRule(runtime, input) {
    return runtime.client.request({
        method: 'POST',
        path: '/v1/config/pricing-rules',
        body: input,
        auth: true,
    });
}
/**
 * Approve a PENDING_APPROVAL version (four-eyes: the server refuses with 403 when the approver is the rule's
 * maker). On approval the rule becomes ACTIVE and prices real quotes for its market + category.
 */
export function approvePricingRule(runtime, pricingVersion, body) {
    return runtime.client.request({
        method: 'POST',
        path: `/v1/config/pricing-rules/${encodeURIComponent(pricingVersion)}/approve`,
        body,
        auth: true,
    });
}
/** The pricing-rule version history for a market + category (DRAFT/PENDING/ACTIVE/ARCHIVED state, rates, audit). */
export function listPricingRules(runtime, q) {
    const params = new URLSearchParams();
    params.set('market', q.market);
    params.set('category', q.category);
    return runtime.client.request({
        method: 'GET',
        path: `/v1/config/pricing-rules?${params.toString()}`,
        auth: true,
    });
}
//# sourceMappingURL=pricing-rules.js.map